import { Component, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { RolesService, UsuarioService } from 'src/app/services/service.index';
import swal2 from 'sweetalert2';

@Component({
  selector: 'app-usuarios',
  templateUrl: './usuarios.component.html',
  styleUrls: ['./usuarios.component.css']
})
export class UsuariosComponent implements OnInit {
  usuarios: any[] = [];
  cols: any[];
  nombre = '';
  roles = [];
  showModalFirmante: boolean = false;
  datosUsuarioFirmante: any = {}
  // Rol del usuario logueado. Si es Supervisor, el listado solo muestra Vendedores
  // y se oculta la opcion de eliminar.
  soySupervisor = false;
  constructor( private usuariosservice: UsuarioService,
                private rolesService: RolesService
   ) {
  }

  ngOnInit(): void {
    const ridLogueado = localStorage.getItem('rid');

    // METODO getAllUsers PARA OBTENER USUARIOS CON SOLO LA INFORMACION NECESARIA PARA ESTA PANTALLA(SIN PASSWORD DIGEST)
    var observableUsers = this.usuariosservice.getAllUsers();
    var observableRoles = this.rolesService.getRoles();
    forkJoin(observableUsers, observableRoles).subscribe(([usuarios, roles]) => {
      this.usuarios = usuarios;
      this.roles = roles
      for (const prop in this.usuarios) {
        const rol = this.roles.find(r => r.id == this.usuarios[prop].role_id);
        this.usuarios[prop].nombrerol = rol?.name || 'Sin rol asignado';

      }

      // Determinar si el usuario logueado es Supervisor. Se hace despues de tener
      // la lista para poder filtrarla en el mismo flujo.
      if (ridLogueado) {
        this.rolesService.getRol(ridLogueado).subscribe(rolResp => {
          const nombreRol = rolResp && rolResp[0] ? rolResp[0].name : '';
          this.soySupervisor = nombreRol === 'Supervisor Gobierno';

          // Si el usuario logueado es Supervisor, mostrar unicamente Vendedores.
          if (this.soySupervisor) {
            this.usuarios = this.usuarios.filter(u => u.job === 'Vendedor');
          }
        });
      }
    });
    this.cols = [

      { field: 'name', header: 'Nombre' },
      { field: 'email', header: 'Correo' },
      { field: 'job', header: 'Puesto' },
      { field: 'gender', header: 'Genero' },
      { field: 'status', header: 'Estatus' },
      { field: 'nombrerol', header: 'Rol' },
      { field: 'herramientas', header: 'Herramientas' },
      { field: 'firmante', header: 'Firmante Empresa' }
  ];

  }

  borrarUsuario(id){
    this.usuariosservice.borrarUsuario(id).subscribe(r => {
      console.log(r);
      swal2.fire('Éxito', 'Usuario eliminado correctamente', 'success');
    }, err => {
      console.log(err);
      try{
        swal2.fire('Atención', err.error.error, 'info')
      }catch{
        swal2.fire('Atención', 'Algo salió mal', 'info')
      }
    })
  }
  verUsuarioFirmante(datarow) {
    this.datosUsuarioFirmante = datarow;
    this.showModalFirmante = true; // Show-Hide Modal Check
  }

  hide() {
    this.showModalFirmante = false;
    this.ngOnInit();
  }

   
  

}
